module.exports = __webpack_public_path__ + "static/img/enrollment_banner.9cfa60e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enrollment_banner.jpg
// module id = GuP9
// module chunks = 1